module.exports = __webpack_public_path__ + "static/1298149992.ee778360.jpg";